export const tinValidationStatuses = {
  PENDING: "pending",
  VALID: "valid",
  INVALID: "invalid",
  MANUAL: "manual",
} as const

export type TinValidationStatusValues =
  (typeof tinValidationStatuses)[keyof typeof tinValidationStatuses]

export const irsStatuses = [
  // "TIN and name control match IRS records",
  "valid",
  // Missing TIN or TIN not 9-digit numeric
  "missing-tin",
  // TIN not currently issued
  "tin-not-issued",
  // "Name/TIN combination does NOT match IRS records",
  "name-tin-mismatch",
  // "Invalid request (i.e., contains alphas, special characters)",
  "invalid-request",
  // "Duplicate request",
  "duplicate-request",
  // "Matched on SSN, when the TIN type is unknown, and a matching TIN and name control is found only on the NAP DM1 database",
  "matched-on-ssn",
  // "Matched on EIN, when the TIN type is unknown, and a matching TIN and name control is found only on the EIN N/C database",
  "matched-on-ein",
  // "Matched on SSN and EIN, when the TIN type is unknown, and a matching TIN and name control is found on both the NAP DM1 and the EIN N/C databases"
  "matched-on-ssn-ein",
] as const

export type IrsStatusValues = (typeof irsStatuses)[number]

export type TinValidation = {
  irsStatus: IrsStatusValues
}
